import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { Breadcrumb, Button, Space, Table, Modal, Input, Dropdown, Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DeleteConfigButton from "./DeleteConfigButton";
import DownloadConfigButton from "./DownloadConfigButton";
import EditConfigButton from "./EditConfigButton";
import ActiveConfigButton from "./ActiveConfigButton";
import ShowMachine from "../Machines/ShowMachine";
import AddConfiguration from "./AddConfiguration";
import { fetchConfigurations } from "../../../redux/Configuration/actions";
import { FilterOutlined } from '@ant-design/icons';

const { Search } = Input;

export default function Configs() {
  const history = useHistory();
  const dispatch = useDispatch();

  const configurations = useSelector(
    (state) => state.configurations?.configurations || []
  );

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [searchFilter, setSearchFilter] = useState('client');

  useEffect(() => {
    dispatch(fetchConfigurations());
  }, [dispatch]);

  const handleSearch = (value) => {
    setSearchInput(value);
  };

  const filteredConfigurations = configurations.filter(config => {
    const searchValue = searchInput.toLowerCase();
    if (!searchInput) return true;

    switch (searchFilter) {
      case 'client':
        return config.user?.username.toLowerCase().includes(searchValue);
      case 'session':
        return config.session?.sessionname.toLowerCase().includes(searchValue);
      case 'configuration':
        return config.confName.toLowerCase().includes(searchValue);
      case 'event':
        return config.event?.eventname.toLowerCase().includes(searchValue);
      default:
        return true;
    }
  });

  const columns = [
    { title: "Configuration Name", dataIndex: "confName", key: "confName" },
    {
      title: "Event Name",
      dataIndex: "eventName",
      key: "eventName",
      render: (_, record) => (
        <Button
          type="link"
          onClick={() => history.push(`/event/${record.eventName?._id}`)}
        >
          View Event Details
        </Button>
      ),
    },
    {
      title: "Machine",
      dataIndex: "machine",
      key: "machine",
      render: (_, record) =><ShowMachine item={record.machine} />,
    },
    { title: "Session Name", dataIndex: "sessionName", key: "sessionName",
      render: (_, record) => <p>{record.sessionName.sessionname}</p>,},
    { title: "User Name", dataIndex: "userName", key: "userName",
      render: (_, record) => <p>{record.userName.username}</p>,},
    { title: "Theme", dataIndex: "theme", key: "theme" },
    { title: "SMS", dataIndex: "SMS", key: "SMS" },
    { title: "Print Mode", dataIndex: "printMode", key: "printMode" },
    { title: "Max Print", dataIndex: "MaxPrint", key: "MaxPrint" },
    { title: "Photo Ratio", dataIndex: "photoRatio", key: "photoRatio" },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
    },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
    },
  ];

  const ConfsActions = filteredConfigurations.map((config) => ({
    key: config._id,
    confName: config.confName,
    eventName: config.event || "N/A",
    machine: config.machine || {},
    sessionName: config.session || "N/A",
    userName: config.user || "N/A",
    theme: config.theme || "DARK",
    SMS: config.SMS ? "Enabled" : "Disabled",
    printMode: config.printMode || "N/A",
    MaxPrint: config.MaxPrint || "N/A",
    photoRatio: config.photoRatio,
    action: (
      <Space size="small">
        <DeleteConfigButton _id={config._id} />
        <EditConfigButton item={config} />
        <DownloadConfigButton eventId={config.event?._id} />
      </Space>
    ),
    active: <ActiveConfigButton isActive={config.isActive} _id={config._id} />,
  }));

  const filterMenu = (
    <Menu>
      <Menu.Item key="client" onClick={() => setSearchFilter('client')}>
        Client
      </Menu.Item>
      <Menu.Item key="session" onClick={() => setSearchFilter('session')}>
        Session
      </Menu.Item>
      <Menu.Item key="configuration" onClick={() => setSearchFilter('configuration')}>
        Configuration
      </Menu.Item>
      <Menu.Item key="event" onClick={() => setSearchFilter('event')}>
        Event
      </Menu.Item>
    </Menu>
  );

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0px" }}>
        <Breadcrumb.Item>Configurations</Breadcrumb.Item>
        <div style={{ float: "right", marginTop: 20 }}>
          <Grid container alignItems="center">
            <Grid item>
              <Search
                placeholder="Search"
                onChange={(e) => handleSearch(e.target.value)}
                style={{ minWidth: 150, maxWidth: 220 }}
                enterButton
              />
              <Dropdown overlay={filterMenu} trigger={['click']}>
                <Button
                  style={{ marginLeft: 10, border: 'none' }}
                  icon={<FilterOutlined />}
                />
              </Dropdown>
              <Button onClick={showModal} type="primary" style={{ marginLeft: 10 }}>
                + Create
              </Button>
            </Grid>
          </Grid>
        </div>
      </Breadcrumb>
      <br />
      <br />
      <Table columns={columns} dataSource={ConfsActions} />

      <Modal
        title="Create New Configuration"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <AddConfiguration onSuccess={handleCancel} />
      </Modal>
    </div>
  );
}
